import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }

import {
  ref,
  toRefs,
  onMounted, toRaw, reactive, watch,
} from 'vue';
import { useI18n } from 'vue-i18n'
import requests from '@/request';
import { fa } from 'element-plus/es/locale';
type BioDialogType = 'user' | 'dic' | 'userGroup' | 'userGroupUser' | 'unitGroup' | 'customField'
    | 'sampleType' | 'product' | 'instrument' | 'storage' | 'project' | 'systemModule' | 'experimentType'| 'crmCustomer' | 'experimentTypeForRdProject' | undefined;


export default /*@__PURE__*/_defineComponent({
  __name: 'BioDialogPublic',
  props: {
    modelValue: {},
    valueId: {},
    valueName: {},
    dicTypeId: {},
    name: { default: "" },
    userGroupId: {},
    dialogType: {},
    paramsBody: { default: ()=>{return {}} },
    moduleId: {},
    field: {},
    label: {},
    editable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: true },
    required: { type: Boolean },
    columns: {},
    multiple: { type: Boolean, default: false },
    id: { default: "" },
    btnList: {}
  },
  emits: ["update:modelValue", "update:valueId", "update:valueName", "choose-item", "change-for-dropdown", "change-for-multi-select"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()

const props = __props;

// Emits定义
const emits = __emit;

let {
  modelValue,
  dicTypeId,
  name,
  userGroupId,
  dialogType,
  paramsBody,
  valueId,
  valueName,
  moduleId,
  field,
  label,
  columns
} = toRefs(props)

// 双向绑定的值对象
var _valueId = ref(valueId);
var _valueName = ref(valueName);

// 是否显示
var _showDialog = ref(false);

// 下拉选项
var _options = ref([])

/**
 * 列字典常量
 */
const BioDialogColumnsConsts = reactive<any>({
  dic: {
    url: "/system/DicType/dictionaryoffrontendcomponents",
    columns: [
      { field: 'id', header: t("BioDialogPublic.id"), style: "", isFilter: true },
      { field: 'name', header: t("BioDialogPublic.name"), style: "", isFilter: true },
      { field: 'createDate', header: t("BioDialogPublic.createDate"), style: "", isFilter: true },
    ],
    label: t('BioDialogPublic.dic.dictionaryDescription'),
    paramsBody: {
      typeId: toRaw(dicTypeId),
    },
    isDto: true,
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.name || "")
    }
  },
  user: {
    url: "/system/user/list",
    columns: [
      // { field: 'id', header: t("BioDialogPublic.id"),   isFilter: true },
      { field: 'username', header: t("BioDialogPublic.id"),   isFilter: true },
      { field: 'name', header: t("BioDialogPublic.name"),   isFilter: true },
      { field: 'departmentName', header: t("BioDialogPublic.departmentName"),   isFilter: true },
      { field: 'createTime', header: t("BioDialogPublic.createDate"),   isFilter: true },
    ],
    label: t('BioDialogPublic.user.selecttheuser'),
    dataKey: "username",
    optionLabel: "name",
    optionValue: "username",
    paramsBody: {},
    isDto: false,
    chooseItem(data) {
      emits('update:valueId', data?.username || "")
      emits('update:valueName', data?.name || "")
    }
  },
  userGroupUser: {
    url: "/system/PersonnelGroup/selectgroupusernewpublic",
    columns: [
      { field: 'username', header: t("Common.Username"),   isFilter: true },
      { field: 'name', header: t("BioDialogPublic.name"),   isFilter: true },
    ],
    dataKey: "username",
    optionLabel: "name",
    optionValue: "username",
    paramsBody: {
      moduleId: moduleId.value,
      field:field.value
    },
    isDto: true,
    label: t('BioDialogPublic.userGroup.selecttheusergroup'),
    chooseItem(data) {
      emits('update:valueId', data?.username || "")
      emits('update:valueName', data?.name || "")
    }
  },
  userGroup: {
    url: "/system/PersonnelGroup/selectgroupnewpublic",
    columns: [
      { field: 'username', header: t("BioDialogPublic.id"),   isFilter: true },
      { field: 'name', header: t("BioDialogPublic.name"),   isFilter: true },
    ],
    dataKey: "id",
    optionLabel: "name",
    optionValue: "id",
    paramsBody: {
      moduleId: moduleId.value,
    },
    isDto: true,
    label: t('BioDialogPublic.userGroup.selecttheusergroup'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.name || "")
    }
  },
  researchTemplate: {
    url: "/experimentalcenter/research/selectNodeInfo",
    columns: [
      { field: 'id', header: "编号",   isFilter: true },
      { field: 'templateName', header: "模版名称",   isFilter: true },
    ],
    dataKey: "id",
    optionLabel: "templateName",
    optionValue: "id",
    paramsBody: {
      type: moduleId.value,
    },
    isDto: true,
    label: t('BioDialogPublic.userGroup.selecttheusergroup'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.templateName || "")
    }
  },

  experimentCenterTemplate: {
    url: "/experimentalcenter/experiment/selectNodeInfo",
    columns: [
      { field: 'id', header: "编号",   isFilter: true },
      { field: 'templateName', header: "模版名称",   isFilter: true },
    ],
    dataKey: "id",
    optionLabel: "templateName",
    optionValue: "id",
    paramsBody: {
      type: moduleId.value,
    },
    isDto: true,
    label: t('BioDialogPublic.userGroup.selecttheusergroup'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.templateName || "")
    }
  },
  unitGroup: {
    url: "/system/UnitGroups/AllUnitGroups",
    columns: [
      { field: 'id', header: t("BioDialogPublic.id"),   isFilter: true },
      { field: 'name', header: t("BioDialogPublic.name"),   isFilter: true },
      { field: 'mark', header: t("BioDialogPublic.primaryUnit"),   isFilter: true },
      { field: 'mark2', header: t("BioDialogPublic.subUnit"),   isFilter: true },
      { field: 'cycle', header: t("BioDialogPublic.ConversionCoefficient"),   isFilter: true },
    ],
    paramsBody: {},
    isDto: false,
    label: t('BioDialogPublic.unitGroup.selecttheunitgroup'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.name || "")
    }
  },
  sampleType: {
    url: "/masterdata/SampleType/selectPopupsSampleType",
    columns: [
      { field: 'code', header: t("BioDialogPublic.id"),   isFilter: true },
      { field: 'name', header: t("BioDialogPublic.name"),   isFilter: true },
      { field: 'createDate', header: t("BioDialogPublic.createDate"),   isFilter: true },
    ],
    paramsBody: {},
    label: t('BioDialogPublic.sampleType.selectthesampletype'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.name || "")
    }
  },
  product: {
    url: "/masterdata/Product/facade/getProductList",
    columns: [
      { field: 'id', header: t("BioDialogPublic.id"),   isFilter: true },
      { field: 'name', header: t("BioDialogPublic.name"),   isFilter: true },
    ],
    paramsBody: {},
    label: t('BioDialogPublic.product.selecttheproduct'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.name || "")
    }
  },
  instrument: {
    url: "/instrument/InstrumentData/AllInstrumentData",
    columns: [
      { field: 'id', header: t("BioDialogPublic.id"),   isFilter: true },
      { field: 'breed', header: t("BioDialogPublic.name"),   isFilter: true },
    ],
    paramsBody: {},
    label: t('BioDialogPublic.instrument.selecttheinstrument'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.name || "")
    }
  },
  storage: {
    url: "/warehouse/inventorymastedata/inventorymastedataListByOne",
    columns: [
      { field: 'id', header: t("BioDialogPublic.id"),   isFilter: true },
      { field: 'name', header: t("BioDialogPublic.name"),   isFilter: true },
    ],
    paramsBody: {},
    label: t('BioDialogPublic.storage.selectthestorage'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.name || "")
    }
  },
  project: {
    url: "/project/ProjectManagement/selectAllProject",
    columns: [
      { field: 'id', header: t("BioDialogPublic.id"),   isFilter: true },
      { field: 'name', header: t("BioDialogPublic.name"),   isFilter: true },
      { field: 'type', header: t("BioDialogPublic.type"),  },
      { field: 'dutyUserName', header: t("BioDialogPublic.dutyUserName"),  },
      { field: 'createDate', header: t("BioDialogPublic.createDate"),  },
    ],
    paramsBody: {},
    label: t('BioDialogPublic.project.selecttheproject'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.name || "")
    }
  },
  systemModule: {
    url: "/activiti/HandleTasks/selectAllApplicationTypeTable",
    columns: [
      { field: 'name', header: t("WorkflowNodeList.orderBlock"),   isFilter: true },
    ],
    paramsBody: {},
    isDto: false,
    label: t('SampleCenterClinicalReceiveEdit.qingxuanze'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.name || "")
    }
  },
  experimentType: {
    url: "/masterdata/ExperimentalConfig/selectFlow",
    columns: [
      {field:"experimentalTypeName",header: t('experimentTemplateEdit.experimentalModule'),isFilter:true,style:'width:800px'},
    ],
    paramsBody: {},
    isDto: true,
    optionValue: "id",
    optionLabel: "experimentalTypeName",
    label: t('SampleCenterClinicalReceiveEdit.qingxuanze'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName',  data?.experimentalTypeName || "")
    }
  },

    experimentTypeForRdProject: {
        url: "/masterdata/ExperimentalConfig/selectFlowForRdProject",
        columns: [
            {field:"experimentalTypeName",header: t('experimentTemplateEdit.experimentalModule'),isFilter:true,style:'width:800px'},
        ],
        paramsBody: {
            type: "rdProject",
        },
        isDto: true,
        optionValue: "id",
        optionLabel: "experimentalTypeName",
        label: t('SampleCenterClinicalReceiveEdit.qingxuanze'),
        chooseItem(data) {
            emits('update:valueId', data?.id || "")
            emits('update:valueName',  data?.experimentalTypeName || "")
        }
    },

  customField: {
    url: "/activiti/workflow/getFiledList",
    columns: [
      {field:"displayName",header:"字段名称",isFilter:true,style:"width: 200px"},
      {field:"columnName",header:"字段",isFilter:true,style:"width: 200px"},
    ],
    paramsBody: {moduleId: moduleId.value},
    isDto: true,
    dataKey: "columnName",
    optionLabel: "displayName",
    optionValue: "columnName",
    label: t('SampleCenterClinicalReceiveEdit.qingxuanze'),
    chooseItem(data) {
      emits('update:valueId', data?.columnName || "")
      emits('update:valueName', data?.displayName ||  "")
    }
  },
  /**
   * 客户管理
   */
  crmCustomer: {
    url: "/customermanage/CrmCustomer/publicDialog/getCustomerList",
    columns: [
      {field: 'name', header: t('OrderList.designation'), isFilter: true},
      {field: 'dutyMan', header: t('OrderList.dutyManId'), isFilter: true},
    ],
    paramsBody: {stateId: '1', typeId: props.dicTypeId},
    isDto: true,
    label: t('SampleCenterClinicalReceiveEdit.qingxuanze'),
    chooseItem(data) {
      emits('update:valueId', data?.id || "")
      emits('update:valueName', data?.name ||  "")
    }
  },
})

watch(()=>props.moduleId, (val)=>{
    BioDialogColumnsConsts[dialogType.value].paramsBody.moduleId = val
})

watch(()=>props.valueId, (val)=>{
  _valueId.value = val
})

watch(()=>props.valueName, (val)=>{
  _valueName.value = val
})

const clickForDropdownButton = () => {
  _showDialog.value = true;
};

/**
 * 表格的chooseItem事件
 * @param data
 */
const _chooseItem = (data) => {
  _showDialog.value = false
  if (BioDialogColumnsConsts[dialogType.value]) {
    BioDialogColumnsConsts[dialogType.value].chooseItem(data)
  }
  emits("choose-item", data);
};

/**
 * 下拉框改变事件
 * @param event
 */
const _changeForDropdown = (event) => {
  if (BioDialogColumnsConsts[dialogType.value]) {
    BioDialogColumnsConsts[dialogType.value].chooseItem(event.value)
  }
  emits("change-for-dropdown", event.value);
  emits("choose-item", event.value);
};
/**
 * 挂载完成后，请求下拉框数据
 */
onMounted(()=>{
  if (BioDialogColumnsConsts[dialogType.value]) {
    let data = paramsBody.value ? { ...paramsBody.value } : {}
    data = {
      ...BioDialogColumnsConsts[dialogType.value]?.paramsBody,
      bioTechLeaguePagingQuery: {
        page: 1,
        rows: 999
      },
      page: 1,
      rows: 999
    }
    requests({
      url: BioDialogColumnsConsts[dialogType.value].url,
      method: 'post',
      data: data
    }).then((res) => {
      _options.value = res.data?.data?.result || []
    }).catch(error=>{console.error(error)})
  }
})

return (_ctx: any,_cache: any) => {
  const _component_BioMultiSelect = _resolveComponent("BioMultiSelect")!
  const _component_BioDropdown = _resolveComponent("BioDropdown")!
  const _component_BioDataTable = _resolveComponent("BioDataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    (props.multiple)
      ? (_openBlock(), _createBlock(_component_BioMultiSelect, {
          key: 0,
          id: _ctx.id,
          options: _unref(_options),
          valueId: _unref(_valueId),
          "onUpdate:valueId": _cache[0] || (_cache[0] = ($event: any) => (_isRef(_valueId) ? (_valueId).value = $event : _valueId = $event)),
          valueName: _unref(_valueName),
          "onUpdate:valueName": _cache[1] || (_cache[1] = ($event: any) => (_isRef(_valueName) ? (_valueName).value = $event : _valueName = $event)),
          label: _unref(label) || BioDialogColumnsConsts[_unref(dialogType)].label,
          "show-button": false,
          "data-key": BioDialogColumnsConsts[_unref(dialogType)]?.dataKey || 'id',
          "option-label": BioDialogColumnsConsts[_unref(dialogType)]?.optionLabel || 'name',
          "option-value": BioDialogColumnsConsts[_unref(dialogType)]?.optionValue || 'id',
          editable: _ctx.editable,
          disabled: _ctx.disabled,
          required: _ctx.required,
          "custom-class": { 'Bio_notEdit' : !_ctx.editable},
          onChange: _changeForDropdown,
          onClickForMultiSelectButton: clickForDropdownButton
        }, null, 8, ["id", "options", "valueId", "valueName", "label", "data-key", "option-label", "option-value", "editable", "disabled", "required", "custom-class"]))
      : (_openBlock(), _createBlock(_component_BioDropdown, {
          key: 1,
          id: _ctx.id,
          options: _unref(_options),
          valueId: _unref(_valueId),
          "onUpdate:valueId": _cache[2] || (_cache[2] = ($event: any) => (_isRef(_valueId) ? (_valueId).value = $event : _valueId = $event)),
          valueName: _unref(_valueName),
          "onUpdate:valueName": _cache[3] || (_cache[3] = ($event: any) => (_isRef(_valueName) ? (_valueName).value = $event : _valueName = $event)),
          label: _unref(label) || BioDialogColumnsConsts[_unref(dialogType)].label,
          "show-button": _ctx.editable && !_ctx.disabled,
          "data-key": BioDialogColumnsConsts[_unref(dialogType)]?.dataKey || 'id',
          "option-label": BioDialogColumnsConsts[_unref(dialogType)]?.optionLabel || 'name',
          "option-value": BioDialogColumnsConsts[_unref(dialogType)]?.optionValue || 'id',
          editable: _ctx.editable,
          disabled: _ctx.disabled,
          required: _ctx.required,
          "custom-class": { 'Bio_notEdit' : !_ctx.editable},
          onChange: _changeForDropdown,
          onClickForDropdownButton: clickForDropdownButton
        }, null, 8, ["id", "options", "valueId", "valueName", "label", "show-button", "data-key", "option-label", "option-value", "editable", "disabled", "required", "custom-class"])),
    _createVNode(_component_Dialog, {
      visible: _unref(_showDialog),
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_isRef(_showDialog) ? (_showDialog).value = $event : _showDialog = $event)),
      modal: "",
      header: _unref(t)('orderListEdit.choose'),
      style: {"min-width":"30vw","max-width":"80vw","min-height":"30vh"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_BioDataTable, {
            buttons: _ctx.btnList?_ctx.btnList:['clear', 'search', 'chooseItem'],
            columns: _unref(columns) && _unref(columns).length ? _unref(columns) : BioDialogColumnsConsts[_unref(dialogType)].columns,
            "operate-column-show": true,
            paramsBody: BioDialogColumnsConsts[_unref(dialogType)].paramsBody,
            rows: 10,
            "is-dto": BioDialogColumnsConsts[_unref(dialogType)].isDto,
            url: BioDialogColumnsConsts[_unref(dialogType)].url,
            "operate-column-style": "min-width: 15%;",
            onChooseItem: _chooseItem
          }, null, 8, ["buttons", "columns", "paramsBody", "is-dto", "url"])
        ])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ]))
}
}

})